import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const API_ROOT = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

export default function DrCollegeList() {
  const navigate = useNavigate();

  const localUser = (() => {
    try {
      return JSON.parse(localStorage.getItem("user") || "null");
    } catch {
      return null;
    }
  })();

  const moduleId = parseInt(localUser?.moduleId, 10);

  const [colleges, setColleges] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState("");
  const [search, setSearch]     = useState("");

  useEffect(() => {
    if (moduleId !== 26) {
      navigate("/");
      return;
    }
    (async () => {
      try {
        const res  = await fetch(`${API_ROOT}/api/college-teachers/college-list?moduleId=${moduleId}`);
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || "Failed to load college list");
        setColleges(Array.isArray(data.data) ? data.data : []);
      } catch (err) {
        setError(err.message || "Failed to load college list");
      } finally {
        setLoading(false);
      }
    })();
  }, [moduleId, navigate]);

  if (moduleId !== 26) return null;

  const thStyle = {
    background: "#008080",
    color: "white",
    border: "1px solid #006666",
    padding: "6px 8px",
    whiteSpace: "nowrap",
    fontWeight: 600
  };
  const tdStyle = {
    border: "1px solid #ddd",
    padding: "5px 8px",
    verticalAlign: "middle"
  };

  const q = search.trim().toLowerCase();
  const filtered = q
    ? colleges.filter(
        (c) =>
          (c.CollegeName || "").toLowerCase().includes(q) ||
          (c.City || "").toLowerCase().includes(q) ||
          (c.State || "").toLowerCase().includes(q) ||
          (c.CollegeType || "").toLowerCase().includes(q)
      )
    : colleges;

  return (
    <div className="container-fluid mt-3">
      <h3 className="ctitle">College List</h3>

      {error && <div className="alert alert-danger">{error}</div>}

      {!error && (
        <div className="mb-3" style={{ maxWidth: 320 }}>
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder="Search by name, city, state, type…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      )}

      {loading ? (
        <div className="text-muted">Loading…</div>
      ) : !error && filtered.length === 0 ? (
        <div className="alert alert-info">No colleges found.</div>
      ) : (
        <div className="table-responsive">
          <table className="table table-sm align-middle" style={{ fontSize: 13, borderCollapse: "collapse", width: "100%" }}>
            <thead>
              <tr>
                <th style={thStyle}>#</th>
                <th style={thStyle}>College Name</th>
                <th style={thStyle}>Address</th>
                <th style={thStyle}>PIN</th>
                <th style={thStyle}>City</th>
                <th style={thStyle}>State</th>
                <th style={thStyle}>Course Offered</th>
                <th style={thStyle}>College Type</th>
                <th style={thStyle}>Contact</th>
                <th style={thStyle}>Alt Contact</th>
                <th style={thStyle}>Email</th>
                <th style={thStyle}>Set Code</th>
                <th style={thStyle}>MCom</th>
                <th style={thStyle}>Approval Type</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((c, idx) => (
                <tr key={c.CollegeID} style={{ background: idx % 2 === 0 ? "#ffffff" : "#f2f2f2" }}>
                  <td style={tdStyle}>{idx + 1}</td>
                  <td style={{ ...tdStyle, whiteSpace: "nowrap" }}>{c.CollegeName}</td>
                  <td style={tdStyle}>{c.Address}</td>
                  <td style={tdStyle}>{c.PIN}</td>
                  <td style={{ ...tdStyle, whiteSpace: "nowrap" }}>{c.City}</td>
                  <td style={{ ...tdStyle, whiteSpace: "nowrap" }}>{c.State}</td>
                  <td style={tdStyle}>{c.CourseOffered}</td>
                  <td style={{ ...tdStyle, whiteSpace: "nowrap" }}>{c.CollegeType}</td>
                  <td style={{ ...tdStyle, whiteSpace: "nowrap" }}>{c.ContactNumber}</td>
                  <td style={{ ...tdStyle, whiteSpace: "nowrap" }}>{c.AContactNumber}</td>
                  <td style={tdStyle}>{c.EMail}</td>
                  <td style={tdStyle}>{c.SetCode}</td>
                  <td style={tdStyle}>{c.MCom}</td>
                  <td style={tdStyle}>{c.ApprovalType}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
